import { appContext } from "../../../../AppContext";
import { IbssPage } from "../../../../Components/Core/BasePage/IbssPage";
import Helper from "../../../../Common/Helper";
import { VirtualTreeView } from "./DataModels";
import { PagedResponse } from "@iconics/core";
import { ApiConstants } from "../../../../Providers.Api/ApiConstants";
import { JSX } from "react";
import { IRouterProps, withRouting } from "@iconics/components";
import { SerendieSymbol } from "@serendie/symbols";
import { ILanguageValues, LanguageValuesHelper } from "@iconics/localisation";
import { Button, ButtonBar, Card, DataGrid, GridContainer, GridItem, IGridData, IGridRowsRequest, IGridRowsResponse, LayoutContainer, LayoutContent, RightButtons } from "@iconics/components";

class ListVirtualTreeViews extends IbssPage<IProps, IState>
{
    private languageValuesHelper: LanguageValuesHelper;

    constructor(props: IProps)
    {
        super(props);
        this.languageValuesHelper = new LanguageValuesHelper(appContext().localisation);

        this.state = {
            canCreate: false,
            gridData: { rows: [] },
        };
    }

    public async componentDidMount(): Promise<void>
    {
        const labels = appContext().labels;
        this.pageTitle = labels.Platform_VirtualTreeView_PageTitle;

        this.setState({
            canCreate: true, // TBD appContext().localStorageProvider.hasRight('DATAMODEL.VirtualTreeViews.Create'),
        });
    }

    private async handleRowsRequest(request: IGridRowsRequest<IVirtualTreeView>): Promise<IGridRowsResponse<IVirtualTreeView>>
    {
        const virtualTreeViews = await appContext().fadxPlatformApiClientV2.v2.core.byTenancy.virtualTreeViews.get<PagedResponse<VirtualTreeView[]>>({
            select: VirtualTreeView,
            skipToken: request.skipToken,
            tenancy: appContext().tenantId,
            top: request.take,
            orderBy: DataGrid.toODataOrderBy(request.sorter),
        });

        return {
            rows: virtualTreeViews.value.map(i => ({
                id: i.Id,
                name: i.Name,
                displayName: this.languageValuesHelper.fromString(i.DisplayName),
                description: i.Description,
                definition: i.Definition,
                ontologyId: i.OntologyId,
                isEnabled: i.IsEnabled,
                eTag: i["@odata.etag"],
            } as IVirtualTreeView)),
            nextSkipToken: virtualTreeViews.skipToken
        };
    }

    public render(): JSX.Element
    {
        const labels = appContext().labels;

        return (
            <LayoutContainer>
                <LayoutContent>
                    <Card
                        title={labels.Platform_VirtualTreeView_ListTitle}
                        subTitle={labels.Platform_VirtualTreeView_ListSubTitle}
                        icon={<SerendieSymbol name='layout-row' />}
                    >
                        <GridContainer>
                            <GridItem>
                                <ButtonBar>
                                    <RightButtons>
                                        <Button
                                            size='small'
                                            styleType='ghost'
                                            leftIcon={<SerendieSymbol name='plus' />}
                                            onClick={() => this.props.navigate(`/admin/virtual-tree-views/new`)}
                                            disabled={!this.state.canCreate}
                                        >
                                            {labels.Platform_CommonAction_Add}
                                        </Button>
                                    </RightButtons>
                                </ButtonBar>
                            </GridItem>
                            <GridItem>
                                <DataGrid
                                    columns={[
                                        {
                                            columnId: Helper.nameOf<VirtualTreeView>("Name"),
                                            title: labels.VirtualTreeView_Name,
                                            getCellValue: i => i.name,
                                            columnWidth: 30,
                                            sortable: true,
                                        },
                                        {
                                            columnId: Helper.nameOf<VirtualTreeView>("DisplayName"),
                                            title: labels.VirtualTreeView_DisplayName,
                                            getCellValue: i => this.languageValuesHelper.getValue(i.displayName),
                                            columnWidth: 30,
                                            sortable: true,
                                        },
                                        {
                                            columnId: Helper.nameOf<VirtualTreeView>("Description"),
                                            title: labels.VirtualTreeView_Description,
                                            getCellValue: i => i.description,
                                            columnWidth: 30,
                                            sortable: true,
                                        },
                                        {
                                            columnId: Helper.nameOf<VirtualTreeView>("IsEnabled"),
                                            title: labels.VirtualTreeView_IsEnabled,
                                            getCellValue: (i) => <SerendieSymbol name={i.isEnabled ? 'check-circle' : 'close-circle'} style={{ marginLeft: '32px' }} />,
                                            columnWidth: 10,
                                            sortable: true,
                                        },
                                    ]}
                                    data={this.state.gridData}
                                    rowId={i => i.id.toString()}
                                    onChange={i => this.setState({ gridData: i })}
                                    onRowsRequest={i => this.handleRowsRequest(i)}
                                    onCellClicked={i => this.props.navigate(`/admin/virtual-tree-views/${i.id}/edit`)}
                                />
                            </GridItem>
                        </GridContainer>
                    </Card>
                </LayoutContent>
            </LayoutContainer>
        );
    }
}

export default withRouting(ListVirtualTreeViews);

export interface IProps extends IRouterProps { }

export interface IState
{
    canCreate: boolean;
    gridData: IGridData<IVirtualTreeView>;
}

export interface IVirtualTreeView
{
    id: number;
    name: string;
    displayName: ILanguageValues;
    description: string;
    definition: string;
    ontologyId: string;
    isEnabled: boolean;
    eTag: string;
}
